import styles from "./button.module.scss";

const Button = ({ children, onClick, style, border }) => {
  let combinedStyle = styles.borderedButton;

  if (Array.isArray(style)) {
    combinedStyle = style.concat(styles.borderedButton).join(" ");
  } else if (typeof style === "object") {
    combinedStyle = Object.entries(style)
      .map(([key, value]) => (value ? key : null))
      .concat(styles.borderedButton)
      .join(" ");
  } else if (typeof style === "string") {
    combinedStyle = `${style} ${styles.borderedButton}`;
  }
  return (
    <div onClick={onClick} className={combinedStyle}>
      <div>{children}</div>
    </div>
  );
};

export default Button;
